
// Generated by dayjs-nuxt-module
import dayjs from 'dayjs'
import 'dayjs/locale/nb'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import updateLocale from 'dayjs/plugin/updateLocale'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(updateLocale)
dayjs.extend(updateLocale)
dayjs.locale('nb')
dayjs.tz.setDefault('Europe/Oslo')


dayjs.updateLocale("nb")

export default dayjs
